import { ReactNode, createContext } from 'react'

/**
 * Supplies a fallback surveyId to {@link useSurveyId} for subtrees that render without a
 * `:surveyId` route param — specifically the multi-market (MultiMarketV2) editor, whose URL
 * is project-scoped. The provider value is the base/master survey (`surveys[0]`).
 *
 * Every `useSurveyId()` call site in that subtree resolves from here: the questionnaire
 * reads/writes (the questionnaire is project-scoped on the backend, which keys the draft by
 * projectId and ignores surveyId on writes — so the base survey is just the ambient context),
 * plus the non-data uses (read-only gating, react keys).
 */
export const SurveyIdContext = createContext<string | undefined>(undefined)

export const SurveyIdProvider = ({
  value,
  children
}: {
  value: string | undefined
  children: ReactNode
}) => (
  <SurveyIdContext.Provider value={value}>{children}</SurveyIdContext.Provider>
)
